import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import axios from 'axios';
import ImplementHelper from 'src/helpers/ImplementHelper';
import { LoadingScreenContext } from 'src/context/LoadingScreenContext';
import { useSettings } from 'src/context/SettingsContext';
import { useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Box, Container, styled } from '@mui/material';
import { setToken } from 'src/helpers/TokenHelper';
import useLogout from 'src/hooks/useLogout';
import NavBar from './NavBar';
import TopBar from './TopBar';

/*const defaultSettings: Settings = {
  direction: 'ltr',
  locale: 'fr_FR',
  responsiveFontSizes: true,
  //theme: 'ONE_DARK',
  theme: 'LIGHT',
};*/

const MainWrapper = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
}));

const PageWrapper = styled('div')(() => ({
  display: 'flex',
  flexGrow: 1,
  paddingBottom: '60px',
  flexDirection: 'column',
  zIndex: 1,
  backgroundColor: 'transparent',
}));

const FullLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();

  //const apiContext = useContext(ApiContext);
  const { saveSettings } = useSettings();
  const { pathname } = useLocation();
  //const navigate = useNavigate();
  const logout = useLogout();

  /*const logout = () => {
    //LogoutHelper.logout(memoizedOrgCode, settings, navigate);
  };*/

  /*useEffect(() => {
        if (sessionStorage.getItem('loginInfos')) {
            const loginInformations: LoginInformationsInterface = JSON.parse(
                sessionStorage.getItem('loginInfos')!
            ) as LoginInformationsInterface;
            if (loginInformations.orgCode === memoizedOrgCode) {
                apiContext.setLoginInfos(loginInformations);
            } else {
                logout();
            }
        } else {
            logout();
        }

        removeSettings(['currentPath']);
    }, []);*/

  const [isNavOpen, setNavOpen] = useState(false);
  const loadingScreenContext = useContext(LoadingScreenContext);

  useEffect(() => {
    const myRequestInterceptor = axios.interceptors.request.use(function (
      request
    ) {
      if (
        request.method &&
        ['POST', 'PUT', 'PATCH', 'DELETE'].includes(
          request.method.toUpperCase()
        )
      ) {
        loadingScreenContext.setLoading(true);
      }
      // Do something with request data
      return request;
    });

    const myResponseInterceptor = axios.interceptors.response.use(
      function (response) {
        loadingScreenContext.setLoading(false);

        if (response.headers['token']) {
          setToken(response.headers['token'] as string);
        }
        return response;
      },
      function (error) {
        loadingScreenContext.setLoading(false);
        if (
          error?.response?.data &&
          ImplementHelper.isErrorType(error.response.data)
        ) {
          enqueueSnackbar(error.response.data.message!, { variant: 'error' });
        } else {
          enqueueSnackbar(String(error), { variant: 'error' });
        }
        if (error?.response?.status) {
          switch (error.response.status) {
            case 401:
              axios.interceptors.response.eject(myResponseInterceptor);
              saveSettings({ currentPath: pathname });
              logout(pathname);
              break;
            default:
              break;
          }
        }
        // Do something with response error
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(myRequestInterceptor);
      axios.interceptors.response.eject(myResponseInterceptor);
    };
  }, [enqueueSnackbar, loadingScreenContext, pathname, saveSettings]);

  return (
    <MainWrapper className="mainwrapper">
      {/* ------------------------------------------- */}
      {/* Main Wrapper */}
      {/* ------------------------------------------- */}
      {/* ------------------------------------------- */}
      {/* Header */}
      {/* ------------------------------------------- */}
      {/*<Header
          // @ts-ignore
          toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
          // @ts-ignore
          toggleMobileSidebar={() => setMobileSidebarOpen(true)}
        />*/}
      <TopBar onNavOpen={() => setNavOpen(!isNavOpen)} />
      {/* ------------------------------------------- */}
      {/* Sidebar */}
      {/* ------------------------------------------- */}
      {/*<Sidebar
        isSidebarOpen={isSidebarOpen}
        isMobileSidebarOpen={isMobileSidebarOpen}
        onSidebarClose={() => setMobileSidebarOpen(false)}
      />*/}
      <NavBar onClose={() => setNavOpen(false)} open={isNavOpen} />
      <PageWrapper className="page-wrapper">
        {/* ------------------------------------------- */}
        {/* PageContent */}
        {/* ------------------------------------------- */}
        <Container
          sx={{
            paddingTop: '95px',
            maxWidth: '1200px',
          }}>
          {/* ------------------------------------------- */}
          {/* Page Route */}
          {/* ------------------------------------------- */}
          <Box sx={{ minHeight: 'calc(100vh - 170px)' }}>{children}</Box>
          {/* ------------------------------------------- */}
          {/* End Page */}
          {/* ------------------------------------------- */}
        </Container>
      </PageWrapper>
    </MainWrapper>
  );
};

export default FullLayout;
